export default {
  'pet-profile:page:title': 'Mijn profiel',
  'pet-profile:header:title': '<p>Een</p> <p>Persoonlijke</p> <p>Selectie</p>',
  'pet-profile:display:not-chosen': 'Niet gekozen',
  'pet-profile:display:breed-not-chosen': '+ Ras toevoegen',
  'pet-profile:display:weight-not-chosen': '+ Gewicht toevoegen',
  'pet-profile:display:age-not-chosen': '+ Leeftijd toevoegen',
  'pet-profile:display:needs-not-chosen': '+ Behoefte toevoegen',
  'pet-profile:display:food-type-not-chosen': '+ Voertype toevoegen',
  'pet-profile:display:your-pet': 'Voor jouw hond',
  'pet-profile:display:edit': 'Bewerken',
  'pet-profile:display:edit-your-pet-profile': 'Bewerk je persoonlijke profiel',
  'pet-profile:display:edit-your-pet-profile:title:empty': 'Maak een profiel voor je viervoeter',
  'pet-profile:display:edit-your-pet-profile:title:filled': 'Profiel bewerken',
  'pet-profile:display:edit-your-pet-profile:subtitle':
    'Voor gerichte productaanbevelingen die echt passen!',
  'pet-profile:display:food-preference': 'Voedingsvoorkeur',
  'pet-profile:cdp:title': 'Woef! Aanbevelingen - afgestemd op jullie behoeften',
  'pet-profile:cdp:title:cat': 'Aanbevelingen voor jouw kat',
  'pet-profile:no-petprofile-page:title': 'Persoonlijke productaanbeveling in 3, 2, 1 …!',
  'pet-profile:no-petprofile-page:text': `Vertel ons de leeftijd, het ras en de bijzondere behoeften van je lieveling en ontvang een persoonlijke productselectie van ons. {br}
        {br}
        Heb je al eerder bij ons besteld? Log dan in op je bestaande account.`,
  'pet-profile:no-petprofile-page:start': 'Voedingsaanbeveling maken',
  'pet-profile:no-petprofile-page:login': 'Nu inloggen',
  'pet-profile:header:your-pet': 'Jouw viervoeter',
  'pet-profile:header:add-profile': 'Nog een profiel aanmaken',
  'pet-profile:placeholder:dog-name': 'Jouw viervoeter',
  'pet-profile:segmentation-update-sheet:weight-error':
    'Gewicht moet tussen {min} en {max} kg liggen',
  'pet-profile:segmentation-update-sheet:name:placeholder': 'Naam invoeren',
  'pet-profile:guide-change-pet-description': 'Hier kun je tussen je profielen wisselen',
  'pet-profile:guide-edit-description': 'Voor een betere ervaring – geef je viervoeter een naam!',
  'pet-profile:segmentation-update-sheet:delete-profile:button': 'Dit profiel verwijderen',
  'pet-profile:segmentation-update-sheet:delete-profile:title': 'Weet je het zeker?',
  'pet-profile:segmentation-update-sheet:delete-profile:text:with-pet-name':
    'Weet je zeker dat je het profiel van {petName} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'pet-profile:segmentation-update-sheet:delete-profile:text:without-pet-name':
    'Weet je zeker dat je je persoonlijke profiel wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'pet-profile:segmentation-update-sheet:delete-profile:confirm': 'Ja, verwijderen',
  'pet-profile:segmentation-update-sheet:delete-profile:cancel': 'Annuleren',
  'pet-profile:error:duplicate-name': 'Je hebt al een bestaand profiel met deze naam.',
  'pet-profile:error:name-required': 'Voer een naam in.',

  'pet-profile:feed-type-selector:title': 'Voersoort & consistentie',
  'pet-profile:feed-type-selector:wet_food': 'Natvoer',
  'pet-profile:feed-type-selector:dry_food': 'Droogvoer',
  'pet-profile:feed-type-selector:snacks': 'Snacks',
  'pet-profile:feed-type-selector:barf': 'BARF',
  'pet-profile:feed-type-selector:wet_food:sauce': 'Saus',
  'pet-profile:feed-type-selector:wet_food:pate': 'Pate',
  'pet-profile:feed-type-selector:wet_food:cream': 'Cream',
  'pet-profile:feed-type-selector:wet_food:description:sauce': 'Sauzen Menu, Juicy Filet',
  'pet-profile:feed-type-selector:wet_food:description:pate': 'Pure Meat, Filet Menu, Meaty Pate',
  'pet-profile:feed-type-selector:wet_food:description:cream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency-title': 'Consistentie',
  'pet-profile:feed-type-selector:consistency:sauce': 'Sauzen',
  'pet-profile:feed-type-selector:consistency:pate': 'Pate',
  'pet-profile:feed-type-selector:consistency:cream': 'Cream',
  'pet-profile:feed-type-selector:consistency:sauce:saucen-menu': 'Sauzen Menu',
  'pet-profile:feed-type-selector:consistency:sauce:juicyfilets': 'Juicy Filet',
  'pet-profile:feed-type-selector:consistency:pate:puremeat': 'Pure Meat',
  'pet-profile:feed-type-selector:consistency:pate:filet-menu': 'Filet Menu',
  'pet-profile:feed-type-selector:consistency:pate:meatypate': 'Meaty Pate',
  'pet-profile:feed-type-selector:consistency:cream:silkycream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency:all': 'Alle consistenties',

  'pet-profile:taste-selector:title': 'Voorkeurssmaak',
  'pet-profile:taste-selector:description':
    'Kies de smaak die je fluweelzachte viervoeter het lekkerst vindt',
  'pet-profile:protein-preference-selector:title': 'Smaken',
  'pet-profile:protein-preference-selector:description':
    'Geef voor elke smaak aan of je kat die lekker vindt, niet lekker vindt of er neutraal tegenover staat.',
  'pet-profile:protein-preference-selector:state:dislike': 'Vind ik niet lekker',
  'pet-profile:protein-preference-selector:state:neutral': 'Neutraal',
  'pet-profile:protein-preference-selector:state:like': 'Vind ik lekker',
  'pet-profile:protein-preference-selector:choice:dislike': 'Vind ik niet lekker',
  'pet-profile:protein-preference-selector:choice:neutral': 'Neutraal',
  'pet-profile:protein-preference-selector:choice:like': 'Vind ik lekker',
  'pet-profile:no-pet-profile:title:dog': 'Zoek je het profiel van je hond?',
  'pet-profile:no-pet-profile:title:cat': 'Zoek je het profiel van je kat?',
  'pet-profile:no-pet-profile:title:name': 'Zoek je het profiel van {name}?',

  'pet-profile:snack-slider:headline:with-name': 'De perfecte aanvulling voor {name}',
  'pet-profile:snack-slider:headline:with-breed': 'De perfecte aanvulling voor {breed}',
  'pet-profile:snack-slider:headline:with-pet-type':
    'De perfecte aanvulling voor {petType, select, cat {jouw kat} other {jouw hond}}',

  'pet-profile:empty-collection:title': 'Geen passend product beschikbaar',
  'pet-profile:empty-collection:description':
    'Verminder het aantal geselecteerde filters om producten te zien.',
  'pet-profile:empty-collection:image-alt': 'Geen passende producten gevonden',

  'pet-profile:empty-profile:title': 'Voeding die echt past',
  'pet-profile:empty-profile:description':
    'Maak een profiel aan voor je hond of kat. Op basis van leeftijd, ras en behoeften bevelen we passende voeding aan.',
  'pet-profile:empty-profile:cta': 'Profiel aanmaken',
  'pet-profile:empty-profile:image-alt': 'Hond en kat met een voerbak',

  'pet-profile:calorie-calculator:title': 'Voedingscalculator',
  'pet-profile:calorie-calculator:subtitle':
    'Bereken in een minuut de optimale dagelijkse voerhoeveelheid voor je viervoeter',
  'pet-profile:calorie-calculator:product-page-hint':
    'Hoe lang het voer meegaat, rekenen we voor je uit op de productpagina. Pas daarvoor eenvoudig de variant en hoeveelheid aan.',
  'pet-profile:calorie-calculator:back-to-product': 'Naar het product',
  'pet-profile:calorie-calculator:start-calculation': 'Berekening starten',
  'pet-profile:calorie-calculator:requires-support:young-dog':
    'Doggos jonger dan 3 maanden hebben persoonlijk advies nodig. Neem contact op met onze voedingsexperts.',
  'pet-profile:calorie-calculator:requires-support:young-cat':
    'Poesjes jonger dan 7 weken hebben persoonlijk advies nodig. Neem contact op met onze voedingsexperts.',
  'pet-profile:calorie-calculator:requires-support:dog':
    'Doggos met speciale behoeften hebben persoonlijk advies nodig. Neem contact op met onze voedingsexperts.',
  'pet-profile:calorie-calculator:requires-support:cat':
    'Katten met speciale behoeften hebben persoonlijk advies nodig. Neem contact op met onze voedingsexperts.',
  'pet-profile:calorie-calculator:kcal-per-day': 'Kcal / dag',
  'pet-profile:calorie-calculator:grams-per-day': 'Gram / dag',
  'pet-profile:calorie-calculator:consultation':
    'Een persoonlijk adviesgesprek met onze voedingsexperts kun je <link>hier</link> inplannen.',
  'pet-profile:calorie-calculator:next': 'Verder',
  'pet-profile:calorie-calculator:yes': 'Ja',
  'pet-profile:calorie-calculator:no': 'Nee',
  'pet-profile:calorie-calculator:days-per-pack:start': 'Voerhoeveelheid berekenen',
  'pet-profile:calorie-calculator:days-per-pack:requires-support':
    'We kunnen de dagelijkse caloriebehoefte vanwege speciale behoeften niet berekenen. Een persoonlijk adviesgesprek met onze voedingsexperts kun je <link>hier</link> boeken.',
  'pet-profile:calorie-calculator:days-per-pack:coverage':
    'De geselecteerde variant & hoeveelheid dekt de behoefte van <strong>{totalDays} {totalDays, plural, one {dag} other {dagen}}</strong>.',
  'pet-profile:calorie-calculator:wizard:loading':
    'Nu wordt er gerekend – jouw voedingsaanbeveling in 3, 2, 1…',
  'pet-profile:calorie-calculator:wizard:date-of-birth:title:dog': 'Wanneer is je doggo geboren?',
  'pet-profile:calorie-calculator:wizard:date-of-birth:title:cat': 'Wanneer is je kat geboren?',
  'pet-profile:calorie-calculator:wizard:breed:title': 'Welk ras beschrijft je doggo het best?',
  'pet-profile:calorie-calculator:wizard:breed:hint':
    'Het ras verraadt veel over energieniveau & stofwisseling. Dat helpt ons de juiste hoeveelheid te vinden.',
  'pet-profile:calorie-calculator:wizard:weight:title':
    'Hoeveel weegt je viervoeter op dit moment?',
  'pet-profile:calorie-calculator:wizard:special-needs:title':
    'Is er iets om rekening mee te houden, zoals...',
  'pet-profile:calorie-calculator:wizard:special-needs:description:dog':
    'Ziektes, dracht, lactatie of een recente operatie kunnen de voedingsbehoeften van je hond beïnvloeden. Geldt een van deze punten voor je viervoeter?',
  'pet-profile:calorie-calculator:wizard:special-needs:description:cat':
    'Ziektes, dracht, lactatie of een recente operatie kunnen de voedingsbehoeften van je kat beïnvloeden. Geldt een van deze punten voor je kat?',
  'pet-profile:calorie-calculator:wizard:sterilized:title:dog':
    'Is je doggo gecastreerd of gesteriliseerd?',
  'pet-profile:calorie-calculator:wizard:sterilized:title:cat':
    'Is je kat gecastreerd of gesteriliseerd?',
  'pet-profile:calorie-calculator:wizard:sterilized:hint:dog':
    'Na een castratie verbruiken veel doggos minder energie – daarom is deze stap zo belangrijk voor de berekening',
  'pet-profile:calorie-calculator:wizard:sterilized:hint:cat':
    'Na een castratie verbruiken veel katten minder energie – daarom is deze stap zo belangrijk voor de berekening',
  'pet-profile:calorie-calculator:wizard:body-condition:title': 'Tijd voor een body-check!',
  'pet-profile:calorie-calculator:wizard:body-condition:description':
    'Let vooral op de taille, ribben en algehele verschijning – zo vind je de juiste inschatting voor je viervoeter.',
  'pet-profile:calorie-calculator:wizard:body-condition:very-lean:title': 'Zeer slank',
  'pet-profile:calorie-calculator:wizard:body-condition:very-lean:description':
    'Ribben goed zichtbaar',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-lean:title': 'Iets te slank',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-lean:description':
    'Taille duidelijk zichtbaar',
  'pet-profile:calorie-calculator:wizard:body-condition:ideal:title': 'Ideaal in vorm',
  'pet-profile:calorie-calculator:wizard:body-condition:ideal:description': 'Ribben licht voelbaar',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-rounded:title': 'Iets rond',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-rounded:description':
    'Weinig taille zichtbaar',
  'pet-profile:calorie-calculator:wizard:body-condition:well-padded:title': 'Goed gevuld',
  'pet-profile:calorie-calculator:wizard:body-condition:well-padded:description':
    'Hangende buik / geen taille',
  'pet-profile:calorie-calculator:wizard:activity-level:title:cat': 'Hoe actief is je poes?',
  'pet-profile:calorie-calculator:wizard:activity-level:title:dog': 'Hoe actief is je doggo?',
  'pet-profile:calorie-calculator:wizard:activity-level:low:title': 'Indoor / Low',
  'pet-profile:calorie-calculator:wizard:activity-level:low:description:cat':
    'Voor katten met een rustig dagelijks leven binnenshuis. Ze bewegen weinig en hebben eerder korte, ontspannen speelmomenten',
  'pet-profile:calorie-calculator:wizard:activity-level:low:description:dog':
    'Tot ongeveer 1 uur rustig wandelen per dag, aangevuld met af en toe spelen (bijv. thuis)',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:title': 'Indoor / Gering',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:description:cat':
    'Voor huiskatten met een actief dagelijks leven. Regelmatig spelen, klimmen en beweging horen vast bij hun dagritme',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:description:dog':
    'Ongeveer 1–2 uur beweging per dag – tussendoor ook met rennen, ballspelen of vergelijkbare activiteiten',
  'pet-profile:calorie-calculator:wizard:activity-level:high:title': 'Outdoor / Actief',
  'pet-profile:calorie-calculator:wizard:activity-level:high:description:cat':
    'Voor katten met vrije toegang naar buiten. Ze zijn veel in beweging, verkennen hun territorium en leggen daarbij ook langere afstanden af',
  'pet-profile:calorie-calculator:wizard:activity-level:high:description:dog':
    'Meer dan 2 uur intensieve beweging in de buitenlucht per dag en/of regelmatige hobbysport (bijv. joggen, agility e.d.)',
  'pet-profile:calorie-calculator:wizard:support:title:special-needs:cat':
    'Wij zorgen voor de behoeften van je poes',
  'pet-profile:calorie-calculator:wizard:support:title:special-needs:dog':
    'Wij zorgen voor de bijzondere behoeften van je hond',
  'pet-profile:calorie-calculator:wizard:support:title:young-dog':
    'Kleine honden, grote verantwoordelijkheid',
  'pet-profile:calorie-calculator:wizard:support:title:young-cat':
    'Kleine poesjes, grote verantwoordelijkheid',
  'pet-profile:calorie-calculator:wizard:support:description:young-dog':
    "Jonge puppy's groeien razendsnel en hebben voeding nodig die precies op hen is afgestemd. Daarom nemen we graag persoonlijk de tijd voor een individueel adviesgesprek – zodat je doggo vanaf het begin de optimale ondersteuning krijgt die hij nodig heeft.",
  'pet-profile:calorie-calculator:wizard:support:description:young-cat':
    'Jonge kittens groeien razendsnel en hebben voeding nodig die precies op hen is afgestemd. Daarom nemen we graag persoonlijk de tijd voor een individueel adviesgesprek – zodat jouw poesje vanaf het begin de optimale ondersteuning krijgt die ze nodig heeft.',
  'pet-profile:calorie-calculator:wizard:support:description:special-needs:dog':
    'Zodat je hond optimaal verzorgd is, raden we een persoonlijk, gratis adviesgesprek aan. Zo stellen we een voedingsplan op dat perfect bij zijn individuele behoeften past.',
  'pet-profile:calorie-calculator:wizard:support:description:special-needs:cat':
    'Zodat je poes optimaal verzorgd is, raden we een persoonlijk, gratis adviesgesprek aan. Zo stellen we een voedingsplan op dat perfect bij haar individuele behoeften past.',
  'pet-profile:calorie-calculator:wizard:support:cta': 'Gratis adviesgesprek inplannen',
  'pet-profile:calorie-calculator:wizard:support:go-back': 'Terug naar de vragen',
  'pet-profile:avatar:image-alt': 'Afbeelding van een {petType}',
};
